import React from "react";
import { Link } from "react-router-dom";

export default function CreativeLabels(props) {
	const { dependentValues, value } = props;
	const { creativeId, libraryId, isSocialCreative } = dependentValues;
	const previewType = isSocialCreative ? "social" : "basic";

	// Values of 0 shouldn't be rendered at all
	if (value === 0) {
		return null;
	}

	return (
		<Link
			to={`/library/${libraryId}/modal/preview-creative/${previewType}/${creativeId}?showLabels=true`}
		>
			{value}
		</Link>
	);
}
